'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddWebItem = require('./components/AddWebItem.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddWebItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/add-web-item/index.js
// module id = 1032
// module chunks = 0